export default function downloadURLContents(url, filename = "download", filetype = ".txt") {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename + filetype); //or any other extension
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
